module.exports = __webpack_public_path__ + "img/cards.162cda7d.webp";